import { Box, DialogContent, DialogContentText } from '@mui/material'
import React from 'react'

const IMAGE_EXTENSIONS = ['png', 'jpg', 'jpeg']
const OFFICE_EXTENSIONS = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx']

export interface DocumentPreviewContentProps {
  url: string
  fileName: string
  fileExtension: string
  isMobileSize?: boolean
}

export const DocumentPreviewContent: React.FC<DocumentPreviewContentProps> = ({
  url,
  fileName,
  fileExtension,
  isMobileSize = false,
}) => {
  const isImageFile = IMAGE_EXTENSIONS.includes(fileExtension)
  const isOfficeFile = OFFICE_EXTENSIONS.includes(fileExtension)
  const isPdfFile = fileExtension === 'pdf'

  if (isImageFile) {
    return (
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
        }}
      >
        <img
          src={url}
          alt={fileName}
          style={{
            maxHeight: '400px',
            height: '100%',
            objectFit: 'contain',
            ...(isMobileSize && {
              maxWidth: '100%',
            }),
          }}
        />
      </Box>
    )
  }

  if (isPdfFile) {
    return (
      <embed
        src={url}
        type="application/pdf"
        style={{ height: isMobileSize ? '80%' : '100%' }}
      />
    )
  }

  if (isOfficeFile) {
    return (
      <iframe
        src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(url)}`}
        style={{
          width: '100%',
          height: isMobileSize ? '80%' : '100%',
          border: 'none',
        }}
        title={fileName}
      />
    )
  }

  return (
    <DialogContent>
      <DialogContentText>
        Preview is not available for this file type. Please download the file
        instead.
      </DialogContentText>
    </DialogContent>
  )
}

export const isPreviewableExtension = (extension: string): boolean => {
  return (
    IMAGE_EXTENSIONS.includes(extension) ||
    OFFICE_EXTENSIONS.includes(extension) ||
    extension === 'pdf'
  )
}
